import {useReducer} from 'react';
import {CurrentUserData, FolderType, UserInfo} from '../types';
import {useQuery} from 'react-query';

export enum UserDataActionType {
  setUser = 'setUser',
  setTheme = 'setTheme',
  setActiveFolder = 'setActiveFolder',
  setEditingFolder = 'setEditingFolder',
  setFolderType = 'setFolderType',
}

export type UserDataGenericAction = UserDataActionType.setTheme;

export interface UserDataSet {
  actionType: UserDataActionType.setUser;
  currentUserId: string;
  userData: UserInfo;
}

export interface SetActiveFolder {
  actionType: UserDataActionType.setActiveFolder;
  folderId: string | undefined;
  folderType: FolderType;
}

export interface SetEditingFolder {
  actionType: UserDataActionType.setEditingFolder;
  folderId: string | undefined;
  folderType: FolderType;
}

export interface SetFolderType {
  actionType: UserDataActionType.setFolderType;
  folderType: FolderType;
}

export type UserDataAction =
  | {actionType: UserDataGenericAction}
  | UserDataSet
  | SetActiveFolder
  | SetFolderType
  | SetEditingFolder;

export interface UserDataResponse {
  userDataState: CurrentUserData;
  userDataDispatch: React.Dispatch<UserDataAction>;
}

const userDataReducer = (
  state: CurrentUserData,
  action: UserDataAction,
): CurrentUserData => {
  const {actionType} = action;
  switch (actionType) {
    case UserDataActionType.setUser:
      return {
        ...state,
        user: action.userData,
      };
    case UserDataActionType.setActiveFolder:
      return {
        ...state,
        currentFolderIds: {
          ...(state.currentFolderIds || {}),
          [action.folderType]: action.folderId,
        },
        isEditingFolder: {
          ...(state.isEditingFolder || {}),
          [action.folderType]: undefined,
        },
      };
    case UserDataActionType.setFolderType:
      return {
        ...state,
        currentFolderType: action.folderType,
      };
    case UserDataActionType.setEditingFolder:
      return {
        ...state,
        isEditingFolder: {
          ...(state.isEditingFolder || {}),
          [action.folderType]: action.folderId,
        },
        currentFolderIds: {
          ...(state.currentFolderIds || {}),
          [action.folderType]: action.folderId,
        },
      };
    default:
      return state;
  }
};

export const useUserData = (): UserDataResponse => {
  // const user = useQuery("UserData", async ()=>await getUserData(), {refetchOnMount:false, refetchOnReconnect:false, refetchOnWindowFocus:false})
  const [userDataState, userDataDispatch] = useReducer(
    userDataReducer,
    {
      user: {},
      currentFolderIds: {},
      colors: {},
      isEditingFolder: {},
    },
  );

  return {
    userDataState,
    userDataDispatch,
  };
};
